let siteName = "智能课评工具";
let clientId = "";
let appCode = "";
let tokenKey = 'AEqAWBnmMj2xEvOLfdzJQlmsChS9CooW';
switch (process.env.srconfig) {
    case "pro":
        clientId = "scrm_open_ai";
        appCode = 'BE964FE5FD840B6F';
        break;
    default:
        //默认开发
        clientId = "scrm_open_ai";
        appCode = 'BE964FE5FD840B6F';
        break;
}
export default {
    clientId,
    appCode,
    siteName,
    tokenKey
};



// WEBPACK FOOTER //
// ./src/rsaConfig.js